import * as React from 'react';
import errorHandler from 'client/utils/error-handler';
import { UserContext } from './UserContext';

const ErrorHandlerUserSetter: React.FunctionComponent = () => {
  const { userId } = React.useContext(UserContext);
  errorHandler.setUser(userId || undefined);
  return null;
};

export default ErrorHandlerUserSetter;
